import React, { useContext, useEffect, useState} from "react";
import { authenticatedContext } from "../App";
import { AlertsContext } from './Layout'
import Table from "./Table";
import { dateObjToStrDate} from "../helpers/date_conversion";
import '../css/aid_records.css'; 
import { confirmAlert } from 'react-confirm-alert';
import { postStuff } from "../helpers/auth";

//    path("aid_records/<str:first_name>/<str:first_name_sort>/<str:last_name>/<str:last_name_sort>/<str:from_day>/<str:to_day>/<str:time_sort>/<str:project_id>/<int:page_n>/", FilterAid.as_view(), name="aid_records"),



const AidRecords = () => {
  const {authenticated, setAuthenticated} = useContext(authenticatedContext);
  const [reqUrl, setReqUrl] = useState("");
  const [updateShit, setUpdateShit] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [firstNameSort, setFirstNameSort] = useState(0);
  const [lastName, setLastName] = useState("");
  const [lastNameSort, setLastNameSort] = useState(0);
  const [timeSort, setTimeSort] = useState(-1);
  const [timeRange, setTimeRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const addAlertBanner = useContext(AlertsContext);

  useEffect(() => {
    const start_d = timeRange[0].startDate ? dateObjToStrDate(timeRange[0].startDate) : "null"
    const end_d = timeRange[0].endDate ? dateObjToStrDate(timeRange[0].endDate) : "null"
    setReqUrl(`/aid_records/${firstName || "null"}/${firstNameSort}/${lastName || "null"}/${lastNameSort}/${start_d}/${end_d}/${timeSort}/${projectList.join(",") || "null"}`);

  },[firstName, firstNameSort, lastName, lastNameSort, timeRange, timeSort, projectList]);

  function handleDeletePress(aid_id){
    confirmAlert({
      title: 'Opravdu chcete smazat podporu?',
      message: 'Tato akce se nedá vrátit.',
      buttons: [
        {
          label: 'Ano',
          onClick: ()=>{deleteFr(aid_id)}
        },
        {
          label: 'Ne'
        }
      ]
    });
  }
  
  function deleteFr(aid_id){
    
    postStuff('aid_record/delete/', {aid_record_id: aid_id}).then((res) => {
          if (res.status === 200) {
              addAlertBanner("Změny uloženy", "success")
              setUpdateShit(!updateShit)

          } else if(res.status === 403){
              addAlertBanner("Na mazání podpory nemáte dostatečné oprávnění", "warning")
              
          }else if (res.status === 401) {
                setAuthenticated(false);
            }
          else {
              addAlertBanner("Něco se pokazilo", "danger")
          }
  });
  }


  return (
    <div className="aid-records">
      <div className="heading-controls">
        <h3>Přehled poskytnuté pomoci</h3>
      </div>
      <Table
        reqUrl={reqUrl}
        redirectOnRecordClick={false}
        updateShit={updateShit}
        headers={[
          {
            name: "Jméno",
            dataKey: "first_name",
            search: {
              value: firstName,
              setValue: setFirstName
            },
            sort: {
              value: firstNameSort,
              setValue: setFirstNameSort
            },
            type: "text",
          },
          {
            name: "Příjmení",
            dataKey: "last_name",
            search: {
              value: lastName,
              setValue: setLastName
            },
            sort: {
              value: lastNameSort,
              setValue: setLastNameSort
            },
            type: "text",
          },
          {
            name: "Čas",
            dataKey: "ts",
            search: {
              value: timeRange,
              setValue: setTimeRange,
              datePickerOpen: datePickerOpen,
              setDatePickerOpen: setDatePickerOpen
            },
            sort: {
              value: timeSort,
              setValue: setTimeSort
            },
            type: "time",
          },
          {
            name:"Projekty",
            dataKey: "project_name",
            search: {
              value: projectList,
              setValue: setProjectList
            },
            sort: false,
            category_options_data_key: "availible_projects",
            type: "category",
          },
          {
            name: "Akce",
            dataKey: false,
            search: false,
            sort: false,
            type: "aid_actions"
        }

      ]} 
        actions={{
          controls:{
            deleteSrc: "/img/svg/bin.svg",
            onDeletePress: handleDeletePress,
          }
        }}
        
        />
    </div>
  );
};

export default AidRecords;